import styled, { css } from '@eduzz/houston-styles';

export const Image = styled.img`
  width: ${props => (props.width ? `${props.width}px` : 'initial')};
  height: ${props => (props.height ? `${props.height}px` : 'initial')};

  ${({ theme }) => css`
  @media only screen and (max-width: ${theme.breakpoints.md}) {
    width: 100%;
`}
`;
